export const ExcludeFalsy = <T>(value?: T | null | false | 0): value is T => Boolean(value)
